module.exports = __webpack_public_path__ + "static/logo-leclerc-6f0ea2ecdb66b4458671be30b88a9446.png";